<div class="content-box task">
  <div class="title-cancel">
    <div class="header-task">
      <i class="far fa-xl" [class]="setTaskIcon(selectedTask.taskType)" triggers="mouseenter:mouseleave"
        [popover]="popoverType"></i>
      <h3>
        {{ selectedTask?.name }}
      </h3>
    </div>

    <div class="header-task">
      <div class="type-sign-box">
        <span class="type-sign-text">{{ selectedTask?.signalingType | enumText: 'SignalingType' }}</span>
      </div>
      <i class="fas fa-flag fa-xl" triggers="mouseenter:mouseleave" [popover]="popoverPriority"
        [class]="selectedTask?.priority"></i>
      <i class="button-icon fas fa-xmark fa-xl cursor-pointer" (click)="closeSideBar()"></i>
    </div>
  </div>
  <div class="form-infos">
    <!-- Informações Gerais -->
    <h3 class="info-title">Informações Gerais</h3>

    <div class="white-box">
      <!-- Informações Gerais -->
      <div class="d-flex align-items-center">
        <i class="fa-solid fa-circle mr-2" [class]="selectedTask?.status"></i>
        {{ selectedTask?.status | enumText: 'TaskStatus' }}
      </div>
      <span class="text-muted">Tipo da Tarefa:
        <span class="text-dark">
          {{ selectedTask?.taskType | enumText: 'TaskType' }}
        </span>
      </span>
      <span class="text-muted">Vertente de Sinalização:
        <span class="text-dark">
          {{ selectedTask?.signalingType | enumText: 'SignalingType' }}
        </span>
      </span>
      <span class="text-muted">Prioridade:
        <span class="text-dark">{{ selectedTask?.priority | enumText: 'TaskPriority' }} </span>
      </span>
      <!-- Informações Gerais -->

      <!-- Data e Hora -->
      <div class="row-gap">
        <!-- Início -->
        <div class="box-date-time" triggers="mouseenter:mouseleave" [popover]="popoverExecution">
          <i class="far fa-calendar-clock"></i>
          <span>
            {{ selectedTask?.executionDate ? (selectedTask?.executionDate | date: 'dd/MM/yyyy') : 'Sem data' }}</span>
        </div>
        <!-- Início -->

        <!-- Fim -->
        <div class="box-date-time" triggers="mouseenter:mouseleave" [popover]="popoverEnd">
          <i class="fas fa-calendar-clock"></i>
          <span> {{ selectedTask?.endDate ? (selectedTask?.endDate | date: 'dd/MM/yyyy') : 'Sem data' }}</span>
        </div>
        <!-- Fim -->

        <!-- Hora -->
        <div class="box-date-time" triggers="mouseenter:mouseleave" [popover]="popoverTime">
          <i class="far fa-timer"></i>
          <span> {{ selectedTask?.resolutionTime ? selectedTask?.resolutionTime + 'h' : '0h' }}</span>
        </div>
        <!-- Hora -->
      </div>
      <!-- Data e Hora -->
    </div>
    <!-- Informações Gerais -->

    <!-- Localização -->
    <h3 class="info-title">Localização</h3>

    <div class="white-box">
      <p class="m-0">
        {{selectedTask?.address
        ? ((selectedTask?.address?.road || '')+', '+(selectedTask?.address?.house_number || '')+'
        - '+(selectedTask?.address?.suburb || '')+', '+(selectedTask?.address?.city || '')+'
        - '+(selectedTask?.address?.state || ''))
        : 'Sem localização'}}
      </p>
      {{selectedTask?.address.postcode ? (selectedTask?.address?.postcode) : 'Sem código postal'}}
    </div>
    <!-- Localização -->

    <!-- Descrição -->
    <h3 class="info-title">Descrição</h3>

    <div class="white-box">
      <p class="m-0" [class.text-muted]="!selectedTask?.description">
        {{ selectedTask?.description ? selectedTask?.description : 'Sem descrição' }}
      </p>
    </div>
    <!-- Descrição -->

    <!-- Atividades da Tarefa -->
    <ng-container *ngIf="activitySigns.length">
      <h3 class="info-title">Atividades da Tarefa</h3>
      <div class="white-box">
        <div class="row d-flex justify-content-between align-items-center text-muted w-100 mx-0 px-1">
          <div class="col-auto px-0" style="font-size: 12px">Atividades</div>
          <div class="col-auto px-0" style="font-size: 12px">
            Progresso {{ taskActivities?.completedActivities + '/' + taskActivities?.activities }}
          </div>
        </div>
        <div class="d-flex w-100" style="padding-right: -4px; padding-left: -4px">
          <div class="progress-task-bar" *ngFor="let activity of taskActivitiesProgress"
            [ngStyle]="{ background: activity ? 'var(--green-base)' : 'var(--snow-dark)' }"></div>
        </div>
        <div class="activity-sign-box" *ngFor="let activity of activitySigns">
          <div class="activity-sign-row">
            <img [src]="activity.signName | enumSvg: 'Signaling'" alt="sign-svg" height="38px" width="38px"
              style=" object-fit: contain;" />
            <p class="m-0 sign-text mx-3">{{ activity.signName | enumText: 'Signaling' }}</p>
          </div>
          <p class="m-0" style="width: max-content">{{ activity?.progress }}</p>
        </div>
      </div>
    </ng-container>
    <!-- Atividades da Tarefa -->

    <!-- Equipes -->
    <ng-container *ngIf="selectedTask?.teamId || selectedTask?.vehicleIds?.length">
      <h3 class="info-title">Equipe</h3>
      <div class="white-box">
        <div class="row mx-0 d-flex align-items-center">
          <ng-container *ngIf="selectedTask?.teamId">
            <img class="team-vehicle-img" [src]="
                selectedTask?.team?.user?.imageURL ? selectedTask?.team?.user?.imageURL : 'assets/icons/camera.svg'
              " alt="team-img" />
            <div class="ml-2 mr-4">{{ selectedTask?.team?.name }}</div>
          </ng-container>
          <ng-container *ngFor="let vehicle of selectedTask?.vehicles">
            <img class="team-vehicle-img" [src]="
                vehicle?.vehicleImage?.url
                  ? vehicle?.vehicleImage.url
                  : 'assets/icons/camera.svg'
              " alt="vehicle-img" />
            <div class="mx-2">{{ vehicle?.licensePlate }}</div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
  <button class="btn-popup button-details">
    <div class="button-div-details">
      <p class="m-0" routerLink="/services/task/resume/task-resume/{{ selectedTask?.id }}">VER TAREFA</p>
      <i class="far fa-angle-right"></i>
    </div>
  </button>
</div>

<!-- Template Popover Tipo de Tarefa  -->
<ng-template #popoverType>
  <span class="popover-info text-white">{{ 'Tarefa de ' + (selectedTask?.taskType | enumText: 'TaskType') }}</span>
</ng-template>
<!-- Template Popover Tipo de Tarefa  -->

<!-- Template Popover Prioridade da Tarefa  -->
<ng-template #popoverPriority>
  <span class="popover-info text-white">{{
    'Prioridade ' + selectedTask?.priority ? (selectedTask?.priority | enumText: 'OrderPriority') : 'Não informado'
    }}</span>
</ng-template>
<!-- Template Popover Prioridade da Tarefa  -->

<!-- Template Popover Status da Tarefa  -->
<ng-template #popoverStatus>
  <span class="popover-info text-white">{{ selectedTask?.status | enumText: 'TaskStatus' }}</span>
</ng-template>
<!-- Template Popover Status da Tarefa  -->

<!-- Template Popover Data Execução  -->
<ng-template #popoverExecution>
  <span class="popover-info text-white">Data de Execução</span>
</ng-template>
<!-- Template Popover Data Execução  -->

<!-- Template Popover Data de Conclusão  -->
<ng-template #popoverEnd>
  <span class="popover-info text-white">Data de Conclusão</span>
</ng-template>
<!-- Template Popover Data de Conclusão  -->

<!-- Template Popover Tempo de Resolução  -->
<ng-template #popoverTime>
  <span class="popover-info text-white">Tempo de Resolução</span>
</ng-template>
<!-- Template Popover Tempo de Resolução  -->

<!-- Template Popover Atrasada para concluir  -->
<ng-template #popoverLate>
  <span class="popover-info text-white">Atrasada para Concluir</span>
</ng-template>
<!-- Template Popover Atrasada para concluir  -->
